export enum TerminalState {
  NO_POWER = 'NO_POWER',
  OFFLINE = 'OFFLINE',
  LOW_POWER = 'LOW_POWER',
  NORMAL = 'NORMAL',
  INCOMPLETE = 'INCOMPLETE',
}
